/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { Typography } from "../Typography";
import { overrideForwardRef } from "../OverridableComponent";

import "./ListSubheader.scss";

export interface IListSubheaderProps {
	className?: string;
	children?: React.ReactNode;
}

export const ListSubheader = overrideForwardRef<IListSubheaderProps, "li">(
	({ Component, className, children }, ref) => {
		const baseClass = BEM("edt-list-subheader");

		if (className) {
			baseClass.add(className);
		}

		return (
			<Component className={baseClass.toClassName()} ref={ref}>
				<Typography truncate>{children}</Typography>
			</Component>
		);
	}
);

ListSubheader.defaultProps = {
	Component: "li"
};
